import { render, staticRenderFns } from "./Chamados.vue?vue&type=template&id=391061a1&scoped=true&"
import script from "./Chamados.vue?vue&type=script&lang=js&"
export * from "./Chamados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391061a1",
  null
  
)

export default component.exports